export enum JobCustomMessageTemplateTypes {
  EMAIL = 'EMAIL',
  SOCIAL_NETWORK_MESSAGE = 'SOCIAL_NETWORK_MESSAGE',
}

export const JobCustomMessageTemplateTypesLabel = {
  [JobCustomMessageTemplateTypes.EMAIL]: 'Email',
  [JobCustomMessageTemplateTypes.SOCIAL_NETWORK_MESSAGE]: 'Social Network Message',
};
